var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendFileIlustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 368,
    height: 225,
    viewBox: "0 0 368 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_1579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.018 46.212H46.2021V179.749H207.018V46.212Z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.304 129.843L177.262 111.222L173.977 102.499H135.107V101.805C135.107 101.792 135.107 101.781 135.107 101.768V99.8656C135.107 99.6723 134.998 99.4869 134.803 99.3502C134.608 99.2135 134.344 99.1367 134.068 99.1367H124.123C123.847 99.1367 123.582 99.2135 123.388 99.3502C123.193 99.4869 123.083 99.6723 123.083 99.8656V102.499L129.486 129.843H132.304Z",
    fill: "#D0CBCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.266 104.488H133C130.961 104.488 129.308 105.647 129.308 107.077V129.03C129.308 130.46 130.961 131.619 133 131.619H180.266C182.306 131.619 183.959 130.46 183.959 129.03V107.077C183.959 105.647 182.306 104.488 180.266 104.488Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2021 104.488H98.4122V131.619H46.2021",
    stroke: "#DFDFDF",
    strokeWidth: 3.14674,
    strokeMiterlimit: 10,
    strokeDasharray: "9.44 9.44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.479 176.992C236.78 176.992 197.095 212.147 197.095 216.877H240.39C240.39 216.877 257.563 207.864 260.081 204.656C262.599 201.449 241.479 176.992 241.479 176.992Z",
    fill: "#E59500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.714 170.065C288.275 172.645 298.603 216.879 298.603 216.879H262.944C262.944 216.879 243.241 189.383 241.478 176.994C250.984 172.748 287.714 170.065 287.714 170.065Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.519 115.93C283.234 115.376 290.615 167.017 287.714 170.063C284.813 173.11 245.682 179.31 241.478 176.993C237.274 174.675 219.852 116.857 259.519 115.93Z",
    fill: "#0079B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.716 131.443C235.903 131.443 226.611 133.309 219.009 136.407C199.916 124.212 195.212 112.772 185.015 112.972C180.197 112.972 175.892 113.447 175.892 116.109C175.892 118.771 180.369 120.839 187.508 120.839C188.698 124.214 204.681 150.272 216.12 150.272C224.051 150.272 246.376 144.076 246.376 142.685C246.376 141.294 239.224 131.443 237.716 131.443Z",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.249 126.998C264.957 130.223 248.605 145.813 244.879 145.727C241.153 145.641 228.108 134.403 229.35 131.18C230.592 127.957 255.637 122.12 261.249 126.998Z",
    fill: "#009AEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.936 103.845C263.936 104.346 264.218 115.341 266.306 118.624C266.306 119.581 251.313 120.207 251.313 118.386V110.383",
    fill: "#D37C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.668 111.357C258.443 111.357 263.935 105.534 263.935 98.3499C263.935 91.1661 258.443 85.3424 251.668 85.3424C244.893 85.3424 239.401 91.1661 239.401 98.3499C239.401 105.534 244.893 111.357 251.668 111.357Z",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.271 104.529H261.964V98.2939C261.044 97.4339 252.151 95.4989 250.004 94.8539C247.857 94.2089 244.177 93.3489 241.724 90.7689C241.163 91.3601 239.841 94.3143 239.492 96.7782C238.572 96.1332 237.124 95.0689 237.124 91.6289C237.124 85.3939 246.017 81.7389 253.684 81.7389C265.951 81.7389 273.004 90.5539 273.004 94.4239C273.004 100.014 267.484 104.529 262.271 104.529Z",
    fill: "#FFD47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.249 102.777C263.07 102.777 264.546 101.742 264.546 100.466C264.546 99.1891 263.07 98.1543 261.249 98.1543C259.428 98.1543 257.952 99.1891 257.952 100.466C257.952 101.742 259.428 102.777 261.249 102.777Z",
    fill: "#DE8E68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.661 71.1288C282.642 71.1288 298.34 74.8354 302.471 74.8354C306.602 74.8354 314.781 74.1409 317.427 74.1409C322.622 74.1409 334.941 78.3334 334.941 85.6671C334.941 90.7776 329.298 93.6092 322.963 95.8624C320.494 96.7374 318.304 100.466 309.494 100.466C295.289 100.466 287.073 86.4776 274.298 86.4776C272.81 86.4776 268.011 86.9377 268.011 88.1976C268.011 89.4575 264.944 87.5698 264.944 86.9786C264.957 81.9519 269.327 71.1288 280.661 71.1288Z",
    fill: "#FFD47F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.018 46.212H46.2021V57.3404H207.018V46.212Z",
    fill: "#DFDFDF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_1579",
    x: -4,
    y: 0,
    width: 376,
    height: 224.879,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_1579"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_1579",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFileIlustration);
export default __webpack_public_path__ + "static/media/send-file-ilustration.983222a783b41ffa5feac98e55571639.svg";
export { ForwardRef as ReactComponent };